import useSequence from '@/composables/useSequence';
import useConfig from '@/composables/useConfig';
import { START_FLOW_ID } from '@/js/constants';

const API_ACTION_TYPES = {
  pause: 'pause',
  resume: 'resume',
};

export function listenClientApi() {
  window.addEventListener('message', (event) => {
    const { action: type, params } = event.data;
    if (!API_ACTION_TYPES[type]) {
      return;
    }

    const { currentSeq, resumeSequence, pauseSequence, interruptSequence, runSequence } = useSequence();
    const { setFlowStateBackToStart, setActiveAvatar } = useConfig();

    switch (type) {
      case API_ACTION_TYPES.pause: {
        pauseSequence();
        break;
      }
      case API_ACTION_TYPES.resume: {
        if (currentSeq.value) {
          if (params.restart) {
            setActiveAvatar();
            interruptSequence();
            setFlowStateBackToStart(START_FLOW_ID);
            runSequence(START_FLOW_ID);
          } else {
            resumeSequence();
          }
        }
        break;
      }
      default:
        break;
    }
  });
}
